var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgMyEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 4.10118L8.82235 7.72646L8.20417 8.1756H4.39232L7.47617 10.4161L7.7123 11.1429L6.53437 14.7682L9.61822 12.5276H10.3823L13.4662 14.7682L12.2883 11.1429L12.5244 10.4161L15.6082 8.1756H11.7964L11.1782 7.72646L10.0003 4.10118ZM7.73191 6.8756L9.38209 1.79688H10.6185L12.2686 6.8756H17.6087L17.9908 8.05146L13.6706 11.1903L15.3207 16.269L14.3205 16.9957L10.0003 13.8569L5.68006 16.9957L4.67981 16.269L6.32999 11.1903L2.00977 8.05146L2.39183 6.8756H7.73191Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyEvents);
export default __webpack_public_path__ + "static/media/my-events.e37752f3a1dfe6f42dc61bcc39be5be1.svg";
export { ForwardRef as ReactComponent };